document.addEventListener('DOMContentLoaded', function() {
    $('.product__slideshow--thumbs').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true,
        asNavFor: '.product__slideshow--main'
    })
    $('.product__slideshow--main').slick({
        adaptiveHeight: true,
        arrows: false,
        asNavFor: '.product__slideshow--thumbs'
    })
})